import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
export var ImageTypeEnum;
(function (ImageTypeEnum) {
    ImageTypeEnum["JPEG"] = "image/jpeg";
    ImageTypeEnum["PNG"] = "image/png";
})(ImageTypeEnum || (ImageTypeEnum = {}));
var ImageService = /** @class */ (function () {
    function ImageService() {
    }
    ImageService.prototype.canvasToBlob = function (canvas, contentType, quality) {
        var _this = this;
        return new Observable(function (observer) {
            if (canvas.toBlob) { // native toBlob support
                canvas.toBlob(function (blob) {
                    observer.next(blob);
                    observer.complete();
                }, contentType, quality);
            }
            else { // fallback support
                var imageData = canvas.toDataURL(contentType, quality);
                var blob = _this.base64ToBlob(imageData, contentType);
                observer.next(blob);
                observer.complete();
            }
        });
    };
    ImageService.prototype.base64ToBlob = function (imageData, contentType) {
        var byteString = atob(imageData.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: contentType });
    };
    ImageService.ngInjectableDef = i0.defineInjectable({ factory: function ImageService_Factory() { return new ImageService(); }, token: ImageService, providedIn: "root" });
    return ImageService;
}());
export { ImageService };
